import LegalLayout, { Section, LEGAL_CONTACT } from "@/components/LegalLayout";

export default function Shipping() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="SHIPPING & DELIVERY."
      intro="Dry powders travel well — here is exactly how yours get to you."
    >
      <Section title="Where we ship">
        <p>We deliver across India, wherever major courier partners operate. We do not ship internationally yet.</p>
      </Section>

      <Section title="Shipping charges">
        <p>Flat ₹49 per order. Free shipping on orders of ₹499 and above. Charges (if any) are shown at checkout before you pay — no surprises.</p>
      </Section>

      <Section title="Dispatch and delivery time">
        <p>Orders are dispatched within 2–3 business days and typically arrive within 3–5 business days of order confirmation. Metro deliveries are usually faster; remote pin codes can take a little longer.</p>
        <p>You get a confirmation call or WhatsApp message before dispatch, and we will ring you on the number you provide at checkout.</p>
      </Section>

      <Section title="Packaging">
        <p>Pouches are resealable, food-grade and moisture-protected, and every consignment is packed to survive the journey. If anything arrives damaged, our refund policy covers you.</p>
      </Section>

      <Section title="Cash on Delivery">
        <p>COD is available across serviceable pin codes. Please keep the exact amount ready — our courier partner may not always carry change. Repeated refusal of COD deliveries may limit COD for your account.</p>
      </Section>

      <Section title="Delays and tracking">
        <p>Sometimes couriers delay (weather, festivals, strikes). If your order is late beyond the promised window, contact us and we will chase it down or refund you. Share your order ID at {LEGAL_CONTACT.email} or {LEGAL_CONTACT.phone} for a status update.</p>
      </Section>
    </LegalLayout>
  );
}
